
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

const CallForDestructionBounty = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedArea, setSelectedArea] = useState<string>("");
  const [isBounty, setIsBounty] = useState<string | null>(null);

  // Extract the selectedArea from location state
  useEffect(() => {
    if (location.state) {
      setSelectedArea(location.state.selectedArea || "");
      
      // Auto-populate for Chevron demonstration - CfD has no bounty
      if (location.state.chevronCall) {
        setIsBounty("no"); // CfD gets no bounty
      }
    }
  }, [location]);

  const handleContinue = () => {
    navigate("/call-for-destruction/creator", { 
      state: { 
        selectedArea,
        isBounty
      } 
    });
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      {/* Logo */}
      <div className="mt-12 mb-6">
        <img 
          src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" 
          alt="iSPAI Logo" 
          className="h-16 cursor-pointer"
          onClick={() => navigate("/engage")}
        />
      </div>

      <Card className="w-full max-w-2xl border border-gray-200">
        <CardContent className="pt-6 px-6 pb-8">
          <div className="mb-4">
            <div className="text-sm text-gray-500 mb-1">Selected Issue Type:</div>
            <div className="font-semibold text-lg">{selectedArea}</div>
          </div>

          <h2 className="text-2xl font-semibold mb-4">Would you like to create a destruction bounty?</h2>
          
          <div className="mb-6">
            <p className="text-gray-600">
              A destruction bounty rewards community members who identify and help remove harmful or inaccurate content from the platform.
            </p>
          </div>

          <RadioGroup 
            value={isBounty || ""} 
            onValueChange={setIsBounty}
            className="space-y-4 mb-8"
          >
            <div className="flex items-start space-x-2 p-3 border rounded-md hover:bg-gray-50">
              <RadioGroupItem value="yes" id="bounty-yes" className="mt-1" />
              <div>
                <Label htmlFor="bounty-yes" className="font-medium">Yes, create a destruction bounty</Label>
                <p className="text-gray-600 text-sm mt-1">
                  Allocate tokens to reward those who help identify and remove problematic content
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-2 p-3 border rounded-md hover:bg-gray-50">
              <RadioGroupItem value="no" id="bounty-no" className="mt-1" />
              <div>
                <Label htmlFor="bounty-no" className="font-medium">No, this is just a removal request</Label>
                <p className="text-gray-600 text-sm mt-1">
                  Submit the request without allocating a token reward
                </p>
              </div>
            </div>
          </RadioGroup>

          <div className="flex justify-between">
            <Button 
              variant="outline" 
              onClick={() => navigate("/call-for-destruction/functional-area")}
              className="border-gray-300"
            >
              Back
            </Button>
            
            <Button 
              onClick={handleContinue}
              disabled={!isBounty}
              className="bg-[#14213d] hover:bg-[#0d1829] text-white px-8 py-2 rounded"
            >
              Continue
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CallForDestructionBounty;
